function post_metafields(meta_data){
	console.log("Updating customer metafields...");
  	console.log(meta_data);
  
	$.ajax({
        type: "POST",
        dataType: "json",
        data: meta_data,
        url: "/a/custmeta",
        success: function (data) {
          var valid = (data.status === 'OK');
          console.log(data)
          if (valid) {
			console.log("Successfully wrote metafield.");
          }
        },
        error: function (jqXHR, textStatus, errorThrown) {
          console.log('AJAX or Server 500 error occurred');
        }
     });


};
